export const APP_VERSION = '50add919f809fe5be5d885d51a6b16c5cb73ff6c'; //
